import { render, staticRenderFns } from "./OptionMajor.vue?vue&type=template&id=4120802e&scoped=true"
import script from "./OptionMajor.vue?vue&type=script&lang=js"
export * from "./OptionMajor.vue?vue&type=script&lang=js"
import style0 from "./OptionMajor.vue?vue&type=style&index=0&id=4120802e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4120802e",
  null
  
)

export default component.exports